import React, { useState } from "react";
import axios from "axios";
import moment from "moment-jalaali";
import "./style.css";
import "../../videocall/modal-vidobo/index.css";

function ScreeningModal({ closeModal, audienceId }) {
  const [message, setMessage] = useState(
    "جهت دریافت تحلیل هوش مصنوعی، روی دکمه‌ی ارسال کلیک کنید"
  );

  const submitMusicoboData = async () => {
    setMessage("هوش مصنوعی در حال تحلیل داده‌های کودک می‌باشد ...");
    const result = await axios.post(
      "https://request.kidiar.com/musicobo/evaluatedata",
      {
        audId: audienceId,
      },
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );
    if (result.data.status == 1) {
      setMessage("احتمال اتیسم در کودک شما وجود ندارد :)");
    } else {
    }
  };

  const SetWorldOfInstruments = (e) => {};

  const SetWorldOfRhythms = (e) => {};

  return (
    <div className="modal-background">
      <div className="modal-container">
        <div className="modal-title">پنل غربالگری اتیسم</div>
        <div className="users-modal-title mode-text-7">
          در اینجا می‌توانید با فشردن دکمه‌ی تحلیل، داده‌های کودک را جهت
          غربالگری اتیسم با هوش مصنوعی، ارسال کنید.
        </div>
        <div
          className="w-90 d-flex justify-content-center align-items-center mode-text-7"
          style={{ height: "100px" }}
        >
          <div>{message}</div>
        </div>
        <div className="modal-footer mode-bg-8">
          <button onClick={() => closeModal(false)}>انصراف</button>
          <button onClick={submitMusicoboData}>ارسال</button>
        </div>
      </div>
    </div>
  );
}

export default ScreeningModal;
